// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__V3TF8","title":"Banner_title__1ku10","subtitle":"Banner_subtitle__PRvT3","pink":"Banner_pink__FxMoL","green":"Banner_green__AvtF3"};